import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Gear } from '../../shared/models/gear.model';
import { PipesModule } from '../../shared/pipes.module';

@Component({
  host: {
    'test-id': 'gear-info',
  },
  imports: [PipesModule],
  selector: 'gear-info',
  styleUrls: ['./gear-info.component.scss'],
  templateUrl: './gear-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GearInfoComponent {
  gear = input.required<Gear>();
}
